import { L10nConfig } from "angular-l10n";
import { environment } from "@base/environments/environment";
import { translationsAR } from 'src/assets/i18n/translation_AR';
import { translationsEC } from "src/assets/i18n/translation_EC";
import { translationsUY } from "src/assets/i18n/translation_UY";
import { Constants } from "./models/constants";

//-------------- Consigo estructura de datos --------------
const getSchemaNode = function (): any[] {
  const schema = [
    {
      locale: {
        language: 'es-AR',
        currency: '$',
        timeZone: 'America/Buenos_Aires',
      },
      dir: 'ltr',
      text: 'Argentina',
    },
  ];
  switch (environment.tenant_id) {
    case Constants.TENANT_ID_EC:
      schema.push({
        locale: {
          language: 'es-EC',
          currency: '$',
          timeZone: 'America/Ecuador',
        },
        dir: 'ltr',
        text: 'Ecuador',
      });
      break;
    
    case Constants.TENANT_ID_UY:
      schema.push({
        locale: {
          language: 'es-UY',
          currency: '$',
          timeZone: 'America/Montevideo',
        },
        dir: 'ltr',
        text: 'Uruguay',
      });
      break;

    default:
      schema.push({
        locale: {
          language: 'es-AR',
          currency: '$',
          timeZone: 'America/Buenos_Aires',
        },
        dir: 'ltr',
        text: 'Argentina',
      });
      break;
  }

  return schema;
};
const schemaNode = getSchemaNode();

//-------------- Obtengo la región --------------
const getDefaultLocaleNode = function (): any {
  switch (environment.tenant_id) {
    case Constants.TENANT_ID_EC:
      return {
        language: 'es-EC',
        currency: '$',
        timeZone: 'America/Montevideo',
      };
    
    case Constants.TENANT_ID_UY:
      return {
        language: 'es-UY',
        currency: '$',
        timeZone: 'America/Montevideo',
      };

    default:
      return {
        language: 'es-AR',
        currency: '$',
        timeZone: 'America/Buenos_Aires',
      };
  }
};
const defaultLocaleNode = getDefaultLocaleNode();

//-------------- Obtengo archivo de traducciones --------------
const getTranslationsList = function (): any {
    switch (environment.tenant_id) {
      case Constants.TENANT_ID_EC:
        return translationsEC;
      
      case Constants.TENANT_ID_UY:
        return translationsUY;

      default:
        return translationsAR;
    }
}
const translationsList = getTranslationsList();


export const l10nConfig: L10nConfig = {
  format: 'language-region',
  providers: [{ name: 'app', asset: translationsList }],
  cache: true,
  keySeparator: '.',
  defaultLocale: defaultLocaleNode,
  schema: schemaNode,
};

